
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    listItems() {
      const items = {}

      this.product.listProperties.forEach(({ name, value }) => {
        if (!items[name]) {
          items[name] = { name, value: [] }
        }

        items[name].value.push(value)
      })

      return Object.values(items)
    },
    textItems() {
      const items = {}

      this.product.textProperties.forEach(({ name, value }) => {
        if (!items[name]) {
          items[name] = { name, value: [] }
        }

        items[name].value.push(value)
      })

      return Object.values(items)
    }
  },
  methods: {
    horizontal(text) {
      return text && text.length < 20
    }
  }
}
